// Inline Variant Selector - replaces popup with inline dropdowns
frappe.ready(() => {
    const $btnConfigure = $('.btn-configure');
    if (!$btnConfigure.length) return;
    
    const itemCode = $btnConfigure.data('item-code');
    const itemName = $btnConfigure.data('item-name');

    // GA4/Meta funnel state (see csl-analytics.js cslTrackEcommerce). PII-safe:
    // only product code / name / numeric price ever leave the page.
    let selectedPrice = 0;          // numeric price_list_rate of the chosen variant
    let selectedCurrency = 'USD';   // currency of the chosen variant price
    let viewItemFired = false;      // fire view_item at most once per PDP load

    // Hide the original button
    $btnConfigure.closest('.mt-5.mb-6').hide();
    
    // Create inline selector container
    const $container = $(`
        <div class="inline-variant-selector mt-4" data-item-code="${itemCode}" data-item-name="${itemName}">
            <div class="variant-stock-status mb-3">
                <span class="stock-label font-weight-bold text-success">IN STOCK</span>
                <span class="sku-label ml-3">SKU <span class="selected-sku">${itemCode}</span></span>
            </div>
            
            <div class="variant-price mb-3">
                <span class="price-label">As low as </span>
                <span class="price-value font-weight-bold" style="font-size: 1.5rem; color: #e67e22;"></span>
            </div>
            
            <div class="attribute-selectors">
                <div class="loading-attributes text-muted">Loading options...</div>
            </div>
            
            <div class="add-to-cart-section mt-4" style="display: none;">
                <div class="d-flex align-items-center flex-wrap">
                    <button class="btn btn-primary btn-add-to-cart-inline mr-3 mb-2" style="min-width: 150px;" disabled>
                        <span class="mr-2">
                            <svg class="icon icon-md"><use href="#icon-assets"></use></svg>
                        </span>
                        Add to Cart
                    </button>
                    <div class="qty-control d-flex align-items-center border rounded mb-2">
                        <button class="btn btn-light qty-btn qty-minus" type="button" style="width: 40px; height: 40px; font-size: 18px; border: none;">−</button>
                        <input type="number" class="form-control text-center qty-input" value="1" min="1" style="width: 60px; border: none; height: 40px;">
                        <button class="btn btn-light qty-btn qty-plus" type="button" style="width: 40px; height: 40px; font-size: 18px; border: none;">+</button>
                    </div>
                </div>
                <div class="selected-variant-info mt-2 text-success" style="display: none;">
                    <small>Selected: <span class="selected-variant-code"></span></small>
                </div>
            </div>
            
            <div class="out-of-stock-message mt-3" style="display: none;">
                <span class="text-danger font-weight-bold">Out of Stock</span>
            </div>
        </div>
    `);
    
    // Insert after product code
    $('.product-code').after($container);
    
    let attributeData = [];
    let selectedAttributes = {};
    let initialStockStatus = {}; // Store initial stock status for each attribute value
    
    // Load attributes
    loadAttributesAndValues();
    
    function loadAttributesAndValues() {
        frappe.call({
            method: 'cslshoes_erp.overrides.variant_selector.get_attributes_and_values_with_stock',
            args: { item_code: itemCode },
            callback: function(r) {
                if (r.message) {
                    attributeData = r.message;
                    // Store initial stock status
                    attributeData.forEach(attr => {
                        initialStockStatus[attr.attribute] = {};
                        attr.values.forEach(v => {
                            initialStockStatus[attr.attribute][v.value] = v.in_stock !== false;
                        });
                    });
                    renderAttributeSelectors();
                }
            },
            error: function(r) {
                console.error('Error loading attributes:', r);
                $('.loading-attributes').text('Error loading options');
            }
        });
    }
    
    function renderAttributeSelectors() {
        const $selectorsContainer = $container.find('.attribute-selectors');
        $selectorsContainer.empty();
        
        attributeData.forEach((attr, index) => {
            const options = attr.values.map(v => {
                const inStock = v.in_stock !== false;
                const stockText = inStock ? '' : ' (Out of Stock)';
                const disabled = inStock ? '' : 'disabled';
                return `<option value="${v.value}" data-in-stock="${inStock}" ${disabled}>${v.value}${stockText}</option>`;
            }).join('');
            
            const $selector = $(`
                <div class="attribute-selector mb-3" data-attribute="${attr.attribute}">
                    <label class="font-weight-bold mb-2" style="display: block;">${attr.attribute} <span class="text-danger">*</span></label>
                    <select class="form-control attribute-dropdown" data-attribute="${attr.attribute}" style="color: #333; background-color: #fff; height: 45px; padding-top: 0; padding-bottom: 0; border: 1px solid #ccc; border-radius: 4px; max-width: 300px;">
                        <option value="">Choose ${attr.attribute}...</option>
                        ${options}
                    </select>
                </div>
            `);
            $selectorsContainer.append($selector);
        });
        
        $container.find('.add-to-cart-section').show();
        $selectorsContainer.find('.attribute-dropdown').on('change', onAttributeChange);

        // GA4 view_item / Meta ViewContent — fire once when the PDP variant
        // selector is ready. Template-level view (no variant chosen yet), so no
        // per-variant price; value defaults to 0. No-ops if tags aren't loaded.
        if (!viewItemFired && window.cslTrackEcommerce) {
            viewItemFired = true;
            window.cslTrackEcommerce('view_item', {
                value: 0, currency: selectedCurrency,
                items: [{ item_id: itemCode, item_name: itemName, price: 0, quantity: 1 }]
            });
        }
    }
    
    function onAttributeChange(e) {
        const $select = $(e.target);
        const attribute = $select.data('attribute');
        const value = $select.val();
        
        if (value) {
            selectedAttributes[attribute] = value;
        } else {
            delete selectedAttributes[attribute];
        }
        
        updateVariantInfo();
    }
    
    function updateVariantInfo() {
        if (Object.keys(selectedAttributes).length === 0) {
            // Reset button state
            const $btn = $container.find('.btn-add-to-cart-inline');
            $btn.prop('disabled', true).removeData('item-code');
            $container.find('.selected-variant-info').hide();
            $container.find('.out-of-stock-message').hide();
            return;
        }
        
        frappe.call({
            method: 'cslshoes_erp.overrides.variant_selector.get_next_attribute_and_values_with_stock',
            args: {
                item_code: itemCode,
                selected_attributes: selectedAttributes
            },
            callback: function(r) {
                if (r.message) {
                    // Only update options for OTHER attributes (cascading), not the one just changed
                    updateOtherDropdownOptions(r.message);
                    updateAddToCartButton(r.message);
                }
            }
        });
    }
    
    function updateOtherDropdownOptions(data) {
        const validOptions = data.valid_options_for_attributes || {};

        $container.find('.attribute-dropdown').each(function() {
            const $select = $(this);
            const attribute = $select.data('attribute');
            const currentValue = $select.val();

            // If this attribute has a selection, don't modify its options
            // This allows user to freely change between in-stock options
            if (selectedAttributes[attribute]) {
                // Reset options to initial stock status
                $select.find('option').each(function() {
                    const $option = $(this);
                    const optionValue = $option.val();

                    if (optionValue === '') return; // Skip placeholder

                    const baseValue = optionValue.split(' (')[0];
                    const inStock = initialStockStatus[attribute] && initialStockStatus[attribute][baseValue];

                    if (inStock) {
                        $option.prop('disabled', false);
                        $option.text(baseValue);
                    } else {
                        $option.prop('disabled', true);
                        $option.text(baseValue + ' (Out of Stock)');
                    }
                });
            } else {
                // For unselected attributes, show cascading filter results
                const validValues = validOptions[attribute] || [];

                $select.find('option').each(function() {
                    const $option = $(this);
                    const optionValue = $option.val();

                    if (optionValue === '') return;

                    const baseValue = optionValue.split(' (')[0];

                    if (validValues.includes(optionValue) || validValues.includes(baseValue)) {
                        $option.prop('disabled', false);
                        $option.text(baseValue);
                    } else {
                        $option.prop('disabled', true);
                        $option.text(baseValue + ' (Unavailable)');
                    }
                });
            }
        });
    }
    
    function updateAddToCartButton(data) {
        const $btn = $container.find('.btn-add-to-cart-inline');
        const $variantInfo = $container.find('.selected-variant-info');
        const $variantCode = $container.find('.selected-variant-code');
        const $stockStatus = $container.find('.stock-label');
        const $outOfStock = $container.find('.out-of-stock-message');
        const $sku = $container.find('.selected-sku');
        const $price = $container.find('.price-value');
        
        if (data.exact_match && data.exact_match.length === 1) {
            const variantCode = data.exact_match[0];
            $btn.data('item-code', variantCode);
            $variantInfo.show();
            $variantCode.text(variantCode);
            $sku.text(variantCode);
            
            if (data.available_qty > 0) {
                $stockStatus.text('IN STOCK').removeClass('text-danger').addClass('text-success');
                $outOfStock.hide();
                $btn.prop('disabled', false);
            } else {
                $stockStatus.text('OUT OF STOCK').removeClass('text-success').addClass('text-danger');
                $outOfStock.show();
                $btn.prop('disabled', true);
            }
            
            if (data.product_info && data.product_info.price) {
                $price.text(data.product_info.price.formatted_price_sales_uom);
                // Capture numeric price for the add_to_cart event payload.
                selectedPrice = Number(data.product_info.price.price_list_rate) || 0;
                selectedCurrency = data.product_info.price.currency || 'USD';
            }
        } else {
            $btn.prop('disabled', true).removeData('item-code');
            $variantInfo.hide();
            $outOfStock.hide();
        }
    }
    
    // Quantity controls
    $container.on('click', '.qty-minus', function() {
        const $input = $container.find('.qty-input');
        const val = parseInt($input.val()) || 1;
        if (val > 1) $input.val(val - 1);
    });
    
    $container.on('click', '.qty-plus', function() {
        const $input = $container.find('.qty-input');
        const val = parseInt($input.val()) || 1;
        $input.val(val + 1);
    });
    
    // Add to cart
    $container.on('click', '.btn-add-to-cart-inline', function() {
        const $btn = $(this);
        const variantCode = $btn.data('item-code');
        const qty = parseInt($container.find('.qty-input').val()) || 1;
        
        if (!variantCode) {
            frappe.msgprint(__('Please select all options'));
            return;
        }
        
        $btn.prop('disabled', true);
        
        webshop.webshop.shopping_cart.update_cart({
            item_code: variantCode,
            qty: qty,
            callback: function(r) {
                $btn.prop('disabled', false);
                if (r.message) {
                    frappe.show_alert({
                        message: __('Added to cart!'),
                        indicator: 'green'
                    });
                    // GA4 add_to_cart / Meta AddToCart — fires only on a confirmed
                    // add. PII-safe: variant code + name + numeric price only.
                    if (window.cslTrackEcommerce) {
                        window.cslTrackEcommerce('add_to_cart', {
                            value: selectedPrice * qty,
                            currency: selectedCurrency,
                            items: [{ item_id: variantCode, item_name: itemName, price: selectedPrice, quantity: qty }]
                        });
                    }
                }
            }
        });
    });
});
